export * from './getTagProps';
